/* ============================================================
   CARDIFF BAKING COMPANY THEME — pickup-scheduler.js
   Calendar + hourly time picker with cart-attribute persistence.
   ============================================================ */

(function () {
  'use strict';

  var WEEKDAY_LABELS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTH_LABELS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function parseIsoDate(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length !== 3) return null;
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
    return { year: y, month: m, day: d };
  }

  function isoFromYMD(y, m, d) {
    return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function parseList(value) {
    if (!value) return [];
    return value.split(/[\s,]+/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function parseWeekdayList(value) {
    return parseList(value).map(function (n) { return parseInt(n, 10); }).filter(function (n) { return !isNaN(n); });
  }

  function shopNow(timezone) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var parts = fmt.formatToParts(new Date());
      var lookup = {};
      parts.forEach(function (p) { lookup[p.type] = p.value; });
      var hour = parseInt(lookup.hour, 10);
      if (hour === 24) hour = 0;
      return {
        year: parseInt(lookup.year, 10),
        month: parseInt(lookup.month, 10),
        day: parseInt(lookup.day, 10),
        hour: hour,
        minute: parseInt(lookup.minute, 10)
      };
    } catch (e) {
      var now = new Date();
      return {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate(),
        hour: now.getHours(),
        minute: now.getMinutes()
      };
    }
  }

  function addHoursToShopNow(now, hoursAhead) {
    var d = new Date(Date.UTC(now.year, now.month - 1, now.day, now.hour, now.minute));
    d.setUTCHours(d.getUTCHours() + hoursAhead);
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth() + 1,
      day: d.getUTCDate(),
      hour: d.getUTCHours(),
      minute: d.getUTCMinutes()
    };
  }

  function compareYMD(a, b) {
    if (a.year !== b.year) return a.year - b.year;
    if (a.month !== b.month) return a.month - b.month;
    return a.day - b.day;
  }

  function weekdayFor(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  }

  function daysInMonth(y, m) {
    return new Date(Date.UTC(y, m, 0)).getUTCDate();
  }

  function formatTimeLabel(hour) {
    var period = hour < 12 ? 'AM' : 'PM';
    var displayHour = hour % 12;
    if (displayHour === 0) displayHour = 12;
    return displayHour + ':00 ' + period;
  }

  function formatWindowLabel(isoDate, time) {
    var ymd = parseIsoDate(isoDate);
    if (!ymd) return '';
    var dt = new Date(Date.UTC(ymd.year, ymd.month - 1, ymd.day));
    var weekday = WEEKDAY_LABELS[dt.getUTCDay()];
    var monthName = MONTH_LABELS[ymd.month - 1];
    var hour = parseInt(time.split(':')[0], 10);
    return weekday + ', ' + monthName + ' ' + ymd.day + ' · ' + formatTimeLabel(hour);
  }

  function init(root) {
    if (!root || root.__pickupSchedulerInit) return;
    root.__pickupSchedulerInit = true;

    var timezone = root.dataset.shopTimezone || 'America/Los_Angeles';
    var openHour = parseInt(root.dataset.openHour, 10);
    var closeHour = parseInt(root.dataset.closeHour, 10);
    var leadTimeHours = parseInt(root.dataset.leadTimeHours, 10);
    var advanceWindowDays = parseInt(root.dataset.advanceWindowDays, 10);
    var closedWeekdays = parseWeekdayList(root.dataset.closedWeekdays);
    var blackoutDates = parseList(root.dataset.blackoutDates);
    var locationLabel = root.dataset.locationLabel || 'Pick up at the bakery';

    var state = {
      fulfillment: root.dataset.initialFulfillment === 'ship' ? 'ship' : 'pickup',
      date: root.dataset.initialDate || '',
      time: root.dataset.initialTime || '',
      viewYear: null,
      viewMonth: null
    };

    var nowYMD = shopNow(timezone);
    var earliestPickupYMDH = addHoursToShopNow(nowYMD, leadTimeHours);
    var earliestYMD = { year: earliestPickupYMDH.year, month: earliestPickupYMDH.month, day: earliestPickupYMDH.day };

    var latestDate = new Date(Date.UTC(nowYMD.year, nowYMD.month - 1, nowYMD.day));
    latestDate.setUTCDate(latestDate.getUTCDate() + advanceWindowDays);
    var latestYMD = {
      year: latestDate.getUTCFullYear(),
      month: latestDate.getUTCMonth() + 1,
      day: latestDate.getUTCDate()
    };

    var pickupFields = root.querySelector('.pickup-scheduler__pickup-fields');
    var radios = root.querySelectorAll('input[name="pickup-fulfillment"]');
    var monthLabel = root.querySelector('[data-pickup-month-label]');
    var daysGrid = root.querySelector('[data-pickup-days]');
    var timeSelect = root.querySelector('[data-pickup-time]');
    var message = root.querySelector('[data-pickup-message]');
    var prevBtn = root.querySelector('[data-pickup-nav="prev"]');
    var nextBtn = root.querySelector('[data-pickup-nav="next"]');

    function setMessage(text) {
      if (!message) return;
      if (text) {
        message.textContent = text;
        message.hidden = false;
      } else {
        message.textContent = '';
        message.hidden = true;
      }
    }

    function isWithinRange(ymd) {
      return compareYMD(ymd, earliestYMD) >= 0 && compareYMD(ymd, latestYMD) <= 0;
    }

    function isBlackedOut(ymd) {
      var iso = isoFromYMD(ymd.year, ymd.month, ymd.day);
      return blackoutDates.indexOf(iso) !== -1;
    }

    function isClosedWeekday(ymd) {
      var w = weekdayFor(ymd.year, ymd.month, ymd.day);
      return closedWeekdays.indexOf(w) !== -1;
    }

    function isSelectable(ymd) {
      return isWithinRange(ymd) && !isBlackedOut(ymd) && !isClosedWeekday(ymd);
    }

    function setViewToEarliestSelectable() {
      var cursor = { year: earliestYMD.year, month: earliestYMD.month, day: earliestYMD.day };
      var lastDay = daysInMonth(latestYMD.year, latestYMD.month);
      var safety = 0;
      while (safety < 366) {
        if (isSelectable(cursor)) {
          state.viewYear = cursor.year;
          state.viewMonth = cursor.month;
          return;
        }
        cursor.day += 1;
        if (cursor.day > daysInMonth(cursor.year, cursor.month)) {
          cursor.day = 1;
          cursor.month += 1;
          if (cursor.month > 12) { cursor.month = 1; cursor.year += 1; }
        }
        if (compareYMD(cursor, latestYMD) > 0) break;
        safety += 1;
        if (cursor.year === latestYMD.year && cursor.month === latestYMD.month && cursor.day > lastDay) break;
      }
      state.viewYear = earliestYMD.year;
      state.viewMonth = earliestYMD.month;
    }

    function renderCalendar() {
      if (!daysGrid || !monthLabel) return;
      monthLabel.textContent = MONTH_LABELS[state.viewMonth - 1] + ' ' + state.viewYear;

      var firstWeekday = weekdayFor(state.viewYear, state.viewMonth, 1);
      var totalDays = daysInMonth(state.viewYear, state.viewMonth);
      var html = '';

      for (var i = 0; i < firstWeekday; i++) {
        html += '<span class="pickup-scheduler__day pickup-scheduler__day--filler" aria-hidden="true"></span>';
      }

      for (var d = 1; d <= totalDays; d++) {
        var ymd = { year: state.viewYear, month: state.viewMonth, day: d };
        var iso = isoFromYMD(ymd.year, ymd.month, ymd.day);
        var selectable = isSelectable(ymd);
        var isSelected = iso === state.date;
        var classes = 'pickup-scheduler__day';
        if (!selectable) classes += ' pickup-scheduler__day--disabled';
        if (isSelected) classes += ' pickup-scheduler__day--selected';

        var attrs = ' role="gridcell" data-pickup-date="' + iso + '"';
        attrs += ' tabindex="' + (selectable ? '0' : '-1') + '"';
        if (!selectable) attrs += ' aria-disabled="true"';
        if (isSelected) attrs += ' aria-selected="true"';

        html += '<button type="button" class="' + classes + '"' + attrs + '>' + d + '</button>';
      }

      daysGrid.innerHTML = html;

      var earliestView = { year: earliestYMD.year, month: earliestYMD.month, day: 1 };
      var latestView = { year: latestYMD.year, month: latestYMD.month, day: 1 };
      var viewYM = { year: state.viewYear, month: state.viewMonth, day: 1 };
      if (prevBtn) prevBtn.disabled = compareYMD(viewYM, earliestView) <= 0;
      if (nextBtn) nextBtn.disabled = compareYMD(viewYM, latestView) >= 0;
    }

    function renderTimes() {
      if (!timeSelect) return;
      if (!state.date) {
        timeSelect.innerHTML = '<option value="">Select a date first</option>';
        timeSelect.disabled = true;
        return;
      }

      var slots = [];
      var earliestHourToday = openHour;
      if (state.date === isoFromYMD(earliestPickupYMDH.year, earliestPickupYMDH.month, earliestPickupYMDH.day)) {
        var threshold = earliestPickupYMDH.hour + (earliestPickupYMDH.minute > 0 ? 1 : 0);
        if (threshold > earliestHourToday) earliestHourToday = threshold;
      }

      for (var h = earliestHourToday; h <= closeHour; h++) {
        slots.push(h);
      }

      if (slots.length === 0) {
        timeSelect.innerHTML = '<option value="">No times available</option>';
        timeSelect.disabled = true;
        return;
      }

      var options = '<option value="">Choose a time</option>';
      slots.forEach(function (h) {
        var value = String(h).padStart(2, '0') + ':00';
        var selected = value === state.time ? ' selected' : '';
        options += '<option value="' + value + '"' + selected + '>' + formatTimeLabel(h) + '</option>';
      });
      timeSelect.innerHTML = options;
      timeSelect.disabled = false;
      if (slots.indexOf(parseInt(state.time.split(':')[0], 10)) === -1) {
        state.time = '';
      }
    }

    function reflectFulfillmentInUI() {
      radios.forEach(function (r) { r.checked = r.value === state.fulfillment; });
      pickupFields.hidden = state.fulfillment !== 'pickup';
    }

    function gateCheckout() {
      var disable = state.fulfillment === 'pickup' && (!state.date || !state.time);
      document.querySelectorAll('[data-checkout-trigger], .cart-drawer__checkout, .cart-checkout').forEach(function (el) {
        if (disable) {
          el.classList.add('pickup-scheduler-blocked');
          el.setAttribute('aria-disabled', 'true');
          if (el.tagName === 'BUTTON') el.disabled = true;
        } else {
          el.classList.remove('pickup-scheduler-blocked');
          el.removeAttribute('aria-disabled');
          if (el.tagName === 'BUTTON') el.disabled = false;
        }
      });

      if (disable) {
        setMessage('Please choose a pickup date and time before checkout.');
      } else if (state.fulfillment === 'pickup' && state.date && state.time) {
        setMessage(locationLabel + ' — ' + formatWindowLabel(state.date, state.time));
      } else {
        setMessage('');
      }
    }

    function persist() {
      var attributes = {};
      attributes['fulfillment_preference'] = state.fulfillment;
      if (state.fulfillment === 'pickup') {
        attributes['pickup_date'] = state.date || '';
        attributes['pickup_time'] = state.time || '';
        attributes['pickup_window_label'] = state.date && state.time ? formatWindowLabel(state.date, state.time) : '';
      } else {
        attributes['pickup_date'] = '';
        attributes['pickup_time'] = '';
        attributes['pickup_window_label'] = '';
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function (err) { console.error('Pickup scheduler persist error:', err); });
    }

    function clickDay(ev) {
      var btn = ev.target.closest('[data-pickup-date]');
      if (!btn || btn.classList.contains('pickup-scheduler__day--disabled')) return;
      state.date = btn.dataset.pickupDate;
      renderCalendar();
      renderTimes();
      gateCheckout();
      persist();
    }

    function changeTime() {
      state.time = timeSelect.value;
      gateCheckout();
      persist();
    }

    function changeFulfillment(ev) {
      state.fulfillment = ev.target.value === 'ship' ? 'ship' : 'pickup';
      if (state.fulfillment === 'ship') {
        state.date = '';
        state.time = '';
      }
      reflectFulfillmentInUI();
      renderCalendar();
      renderTimes();
      gateCheckout();
      persist();
    }

    function navigate(direction) {
      var delta = direction === 'next' ? 1 : -1;
      var newMonth = state.viewMonth + delta;
      var newYear = state.viewYear;
      if (newMonth < 1) { newMonth = 12; newYear -= 1; }
      if (newMonth > 12) { newMonth = 1; newYear += 1; }
      state.viewMonth = newMonth;
      state.viewYear = newYear;
      renderCalendar();
    }

    radios.forEach(function (r) { r.addEventListener('change', changeFulfillment); });
    if (daysGrid) daysGrid.addEventListener('click', clickDay);
    if (timeSelect) timeSelect.addEventListener('change', changeTime);
    if (prevBtn) prevBtn.addEventListener('click', function () { navigate('prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { navigate('next'); });

    var storedYMD = parseIsoDate(state.date);
    if (storedYMD && isSelectable(storedYMD)) {
      state.viewYear = storedYMD.year;
      state.viewMonth = storedYMD.month;
    } else {
      if (state.date) {
        state.date = '';
        state.time = '';
        if (state.fulfillment === 'pickup') {
          setTimeout(persist, 0);
        }
      }
      setViewToEarliestSelectable();
    }

    reflectFulfillmentInUI();
    renderCalendar();
    renderTimes();
    gateCheckout();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pickup-scheduler]');
    nodes.forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('pickup-scheduler:refresh', function () { initAll(document); });

  window.PickupScheduler = { refresh: function () { initAll(document); } };
})();
